import { render, staticRenderFns } from "./clientDetails.vue?vue&type=template&id=6bb02537&scoped=true&"
import script from "./clientDetails.vue?vue&type=script&lang=js&"
export * from "./clientDetails.vue?vue&type=script&lang=js&"
import style0 from "./clientDetails.vue?vue&type=style&index=0&id=6bb02537&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb02537",
  null
  
)

export default component.exports